import { twMerge } from 'tailwind-merge';
import type { DecoratedUnisonProjectTask } from '@witmetrics/utils';
import { getProjectTitleWithPatient } from '@witmetrics/unison-core';
import { useAppState } from '@/providers/AppStateProvider';
import TruncatedText from '@/components/TruncatedText';
import DueDate from './DueDate';
import { classes } from './utils';

export type UnisonProjectTaskHeaderProps = {
  onlyTime?: boolean;
  unisonProjectTask: DecoratedUnisonProjectTask;
};

export default function UnisonProjectTaskHeader({
  onlyTime,
  unisonProjectTask: { task, unisonProject },
}: UnisonProjectTaskHeaderProps) {
  const { onSelectProject } = useAppState();

  return (
    <div className={classes.wrapper}>
      <TruncatedText
        className={twMerge(classes.name, task.isResolved && classes.resolved)}
        tooltipPlacement="top"
        onClick={() => onSelectProject(unisonProject.id)}>
        {getProjectTitleWithPatient(unisonProject)}
      </TruncatedText>
      <DueDate onlyTime={onlyTime} task={task} />
    </div>
  );
}
